import React, { useMemo } from 'react';
import { Box, Container, Typography } from '@mui/material';
import hospitalImage from '../../assets/homepageimages/hospital-image.webp';
import emergencyImage from '../../assets/homepageimages/emergency-service.webp';
import diagnosticImage from '../../assets/homepageimages/diagnostic-services.webp';
import { useLocation } from 'react-router-dom';
import useServicePageContent from '../../hooks/useServicePageContent';
import HeroBackground from './HeroBackground';

const serviceBackgrounds = {
  medical: hospitalImage,
  surgical: hospitalImage,
  diagnostic: diagnosticImage,
  radiology: hospitalImage,
  emergency: emergencyImage,
  departments: hospitalImage,
  admission: hospitalImage,
  rooms: hospitalImage,
  icu: hospitalImage,
  'surgical-icu': hospitalImage,
  neonatal: hospitalImage,
  cardiac: hospitalImage,
  hdu: hospitalImage,
  pathology: diagnosticImage,
  endoscopy: diagnosticImage,
  echo: hospitalImage,
  dialysis: diagnosticImage,
  daycare: hospitalImage,
  general: hospitalImage,
};

const ServicesHero = ({ title, subtitle, serviceType = 'general' }) => {
  const location = useLocation();
  const slug =
    (location.pathname || '').replace(/^\/services\//, '').replace(/^\/+/, '') ||
    'services';
  const { content } = useServicePageContent(slug, { title, subtitle });

  const backgroundImage = useMemo(
    () =>
      content.heroImageUrl ||
      serviceBackgrounds[serviceType] ||
      serviceBackgrounds.general,
    [content.heroImageUrl, serviceType]
  );

  return (
    <Box
      sx={{
        position: 'relative',
        height: { xs: '50vh', sm: '60vh', md: '70vh' },
        minHeight: { xs: 300, sm: 400, md: 500 },
        overflow: 'hidden',
      }}
    >
      <HeroBackground src={backgroundImage} alt="" priority>
        <Container
          maxWidth="lg"
          sx={{
            position: 'relative',
            zIndex: 2,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ textAlign: 'center', color: 'white' }}>
            <Typography
              variant="h2"
              component="h1"
              gutterBottom
              sx={{
                fontWeight: 'bold',
                fontSize: { xs: '2rem', sm: '3rem', md: '4rem' },
                textShadow: '0px 2px 4px rgba(0,0,0,0.3)',
                mb: 2,
              }}
            >
              {content.title || title}
            </Typography>
            <Typography
              variant="h5"
              sx={{
                opacity: 0.95,
                fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.5rem' },
                textShadow: '0px 1px 2px rgba(0,0,0,0.3)',
                maxWidth: 800,
                mx: 'auto',
                lineHeight: 1.4,
              }}
            >
              {content.subtitle || subtitle}
            </Typography>
          </Box>
        </Container>
      </HeroBackground>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.05"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
          opacity: 0.3,
          zIndex: 1,
          pointerEvents: 'none',
        }}
      />
    </Box>
  );
};

export default ServicesHero;
